import Text from "../../../components/ui/Text";
import gameImg from "../assets/images/game.png";
import xImage from "../assets/images/x.png";

interface Props {
  className?: string;
  description?: string;
  titleWords: { word: string; isHighlighted?: boolean }[];
  onClose: () => void;
}

const Header = ({
  className = "",
  titleWords,
  description = "On this menu you can manage your character and watch some statistics about it",
  onClose,
}: Props) => {
  return (
    <div
      className={`rounded-[6px] p-3 px-5 w-full flex items-center justify-between bg-gradient-to-r from-[#242939]/30 via-[#596070]/80 to-[#242939]/30 ${className}`}
    >
      <div className="flex items-center justify-between space-x-10 w-full">
        {/** Left */}
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <img src={gameImg} alt="Game" className="w-[35px] h-[26px] mr-2" />
            {titleWords?.map(({ word, isHighlighted }, i) => (
              <Text
                size="2xl"
                key={i}
                style={{
                  textShadow: isHighlighted
                    ? "-8px -5px 8px  rgba(86, 245, 255, 0.3)"
                    : "auto",
                }}
                className={` relative bebas-neue-font !font-[500] ${
                  isHighlighted ? "text-[#56F5FF]   " : "text-white  "
                }`}
              >
                {word}
              </Text>
            ))}
          </div>

          <Text
            size="xxs"
            className="text-white/50 font-gilroy max-w-[300px] leading-[1.2]"
          >
            {description}
          </Text>
        </div>

        {/** Right */}
        <button
          title="Close"
          onClick={onClose}
          className="bg-[#A42A2A] rounded-md active:scale-95 transition hover:opacity-70 border-[1px] border-[#DD3030] p-3"
        >
          <img src={xImage} alt="X" className="w-[18px] h-[18px]" />
        </button>
      </div>
    </div>
  );
};

export default Header;
